var dropdownSubTriggerIndicatorIcon = 'subTriggerIndicator_dropdownSubTriggerIndicatorIcon__lw32sy0';

export { dropdownSubTriggerIndicatorIcon };
//# sourceMappingURL=subTriggerIndicator.vanilla.mjs.map
